// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"bacaf9a1","87":"698fdf64","142":"f1ee7f05","184":"8eb5c838","264":"c8ca0899","536":"78578684"}[chunkId] + ".chunk.js";
};